export const importantNotifications = [
  'card_bought',
  'award_unlocked',
  'card_attached',
];
